// import i18n from '@/plugins/i18n'

export default [
  // {
  //   path: 'wallet',
  //   name: 'wallet',
  //   component: () => import('@/app/M2001Coins/PgWallet'),
  //   meta: { authenticated: true, permissions: ['wallet.viewOwn'] }
  // },
  {
    path: 'toStripe',
    name: 'M2001CoinsToStripe',
    component: () => import('@/app/M2001Coins/PgToStripe'),
    portalGroup: 'all.my',
    meta: { authenticated: true }
  },
  {
    path: 'topup',
    name: 'topup',
    component: () => import('@/app/M2001Coins/PgTopup'),
    portalGroup: 'all.my',
    meta: { authenticated: true, permissions: ['wallet.viewOwn'] }
  }
]
